import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-control-errors',
  templateUrl: './form-control-errors.component.html',
  styles: [`
  .text-danger {
    font-size: 12px;
  }`]
})
export class FormControlErrorsComponent implements OnInit {

  @Input() control: FormControl;
  @Input() displayName: String;
  @Input() errorMsg: String;
  @Input() compareDisplayName: String;
  @Input() isMobile: boolean;
  @Input() issaid: boolean;
  @Input() isShowKeyPress: boolean;
  @Input() showErrorMsg: boolean;
  @Input() showNgErrorMsg: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.control?.currentValue != changes?.control?.previousValue) {

    }
  }
}
